import { AxiosInstance } from "axios"
import { MerchantIdCards } from "./idCardsTypes"

export enum MerchantSettingsIdCards {
    ID_CARDS = "id-cards-for-merchant",
}

export type FetchIdCardsResponse = Readonly<{
    userCards: MerchantIdCards[]
}>

type FetchIdCardsParams = Readonly<{
    merchantId: number
    from: string
    to: string
    isActive?: boolean
    cardNumber?: string
    customerId?: string
    customerGroupId?: string
}>

export async function fetchIdCards(
    { merchantId, ...rest }: FetchIdCardsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchIdCardsResponse> {
    const url = `/merchants/${merchantId}/userCards`

    const response = await axios.get(url, {
        params: rest,
        signal,
    })

    return response.data
}
